// extracted by mini-css-extract-plugin
export default {"notice":"_4uczM","resend":"jxWdw","skeleton-progress":"cE57g"};